import Hammer from 'hammerjs'

export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_SCALE = 100
export const ANIMATED_ZOOM_STEP = 5
export const MIN_ZOOM_STEP = 25
export const MIN_ZOOM = 0.25
export const MAX_ZOOM = 8
export const FILE_NAME_MAX_LEN = 40

export const ZOOM_ACTIONS = {
  INC: 'INC',
  DEC: 'DEC',
}

export const HAMMER_OPTIONS = {
  pan: {
    direction: Hammer.DIRECTION_ALL,
    threshold: 0,
  },
  swipe: {
    direction: Hammer.DIRECTION_HORIZONTAL,
    threshold: 100,
  },
  tap: {
    event: 'doubletap',
    taps: 2,
    threshold: 10,
  },
  pinch: { enable: true },
}

export const DEFAULT_SCROLL_POSITION = {
  left: 0,
  top: 0,
  x: 0,
  y: 0,
}
